"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyAttrFormatter = anyAttrFormatter;
const cloneDeep_js_1 = require("../../../utils/cloneDeep.js");
function* anyAttrFormatter(_, rawValue, options = {}) {
    const { format = true, transform = true } = options;
    let transformedValue = undefined;
    if (transform) {
        transformedValue = (0, cloneDeep_js_1.cloneDeep)(rawValue);
        if (format) {
            yield transformedValue;
        }
        else {
            return transformedValue;
        }
    }
    const formattedValue = transformedValue !== null && transformedValue !== void 0 ? transformedValue : (0, cloneDeep_js_1.cloneDeep)(rawValue);
    return formattedValue;
}
